import http from './index'
export default {
  //  获取看板列表
  getDataViewList (params) {
    return http.get('/front/displayBoard/list', params)
  },
  // 查看看板详情
  getDataViewDetail (params) {
    return http.get('/front/displayBoard/detail', params)
  },
  // 删除看板
  delDataView (params) {
    return http.post(`/front/displayBoard/delete/${params.boardId}`)
  },
  // 更新看板数据
  updateDataView (params) {
    return http.post('/front/displayBoard/save', params)
  },
  // 获取支持看板部件的组件列表
  getComponentList (params) {
    return http.get('/front/displayBoard/widget/componentList', params)
  },
  // 获取全部部件列表
  getWidgetList (params) {
    return http.get('/front/displayBoard/widget/list', params)
  }
}
